// 通用字体
import 'vfonts/Lato.css'
// 等宽字体
import 'vfonts/FiraCode.css'

import 'nprogress/nprogress.css'

import 'highlight.js/styles/default.css'

import 'vue-advanced-cropper/dist/style.css'

import '@/utils/image-main-color.js'
// 阿里自适应插件
// import 'amfe-flexible'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import mitt from 'mitt'
// @ts-ignore
import { fabric } from 'fabric-with-erasing'

import App from './App.vue'
import router from './router'
import i18n from '@/i18n'
import VueColorAvatar from '@/components/account/VueColorAvatar.vue'
import UglyAvatar from '@/components/account/UglyAvatar.vue'
import VueKonva from 'vue-konva'

export const bus = mitt()
const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(VueKonva)

// 再注册全局事件总线
app.config.globalProperties.$bus = bus
// 设置fabric选中样式
fabric.Object.prototype.set({
  borderColor: '#663dcc',
  cornerColor: '#a91ccc',
  cornerStrokeColor: '#663dcc',
  borderDashArray: [5, 5],
  cornerSize: 10,
  transparentCorners: false
})

// 全局注册组件，但只注册一次
app.component('VueColorAvatar', VueColorAvatar)
app.component('UglyAvatar', UglyAvatar)

app.mount('#app')